<div class="app-ghost-container" id="appContainer"><KryptonRedirectIframe ref="redirectIframe" v-bind="redirectAttrs"></KryptonRedirectIframe></div>